import React, {
    useState,
} from 'react'
import {
    Alert,
    Col, Spinner,
    Row, Button,
    Form, Modal
} from 'react-bootstrap'
import { colors } from '../../styles/colors'
import { useTranslation } from 'react-i18next'
import ModalComponent from '../Modals/ModalComponent'
import { getLanguageValue } from '../../utils/getLanguageValue'
import { formatedDate } from '../../utils/formatedDate'
import { FileTypeIcon } from '../../utils/getFileTypeIcon'
import apiClient from '../../utils/api/apiClient'
import { APIEndpoints } from '../../utils/api/apiConfig'
import DocumentDeleteIcon from "../../assets/icons/document_delete.png"
import DocumentReactivateIcon from "../../assets/icons/document_exchange.png"
import styled from 'styled-components';
import { makeCall } from '../../utils/api/makeCall'
import useMountEffect from '../../utils/hooks/useMountEffect';
const StyledImage = styled.div`
height:24px;
width:24px;
background-size: contain;
background-image: none;
background-image: url(${props => props.image ? props.image : ""});
`
const StyledDocumentWrapper = styled.a`
    min-height: 48px;
    color: ${colors.gray4};
    small {
        color: ${colors.gray3};
    }
    display: flex;
    align-items: center;
    margin: 5px 5px 5px 0 ;
    cursor: pointer;
`
const HistoryDocumentModal = ({ documentData, handleClose }) => {
    const [/*errorStates*/, setErrorStates] = useState({})
    const [loadingStates, setLoadingStates] = useState({})

    const [documents, setDocuments] = useState([])
    const [document, setDocument] = useState(null)

    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [openReactivateModal, setOpenReactivateModal] = useState(false)
    async function loadDocuments(id) {
        await makeCall('loadDocuments', async () => {
            let resp = await apiClient.getJson(APIEndpoints.documentAdmin(documentData.id).history)
            setDocuments(resp)
        }, setErrorStates, setLoadingStates)
    }
    async function reactivateDocument(id) {
        await makeCall('reactivateDocument', async () => {
            await apiClient.postJson(APIEndpoints.documentAdmin(id).reactivate)
        }, setErrorStates, setLoadingStates)
    }
    async function removeDocument(id) {
        await makeCall('removeDocument', async () => {
            await apiClient.deleteJson(APIEndpoints.documentAdmin(id).documents)
        }, setErrorStates, setLoadingStates)
    }
    const handleDeleteDocument = async () => {
        await removeDocument(document.id)
        handleClose(true)
    }
    const handleReactivateDocument = async () => {
        await reactivateDocument(document.id)
        handleClose(true)
    }
    const { t } = useTranslation()

    useMountEffect(() => {
        loadDocuments()
    })

    return (
        <div>
            {/* enforceFocus for OverlayRight with overLayZIndex with inputs  */}
            <Modal show={true} size="lg" onHide={handleClose} enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('documents:history')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {loadingStates.loadDocuments && (

                            <div className='d-flex justify-content-center'>
                                <Spinner animation='border' variant='primary' />
                            </div>
                        )}
                        {!loadingStates.loadDocuments && documents.length === 0 && (

                            <Alert variant='info'>
                                {t('documents:noDocumentsExists')}
                            </Alert>
                        )}
                        {documents.map((item, index) => {
                            return (
                                <Row className='added-row' key={index}>
                                    <Col>
                                        <div className="d-flex justify-content-start">
                                            <StyledDocumentWrapper href={item.url} download={item.name} filename={item.name} target="_blank">
                                                <FileTypeIcon fileType={item.type} />
                                                <div >
                                                    <div className='fw-bold'>{item.name || ''}</div>
                                                    {getLanguageValue(item.description.values) && <div>
                                                        <small className='text-uppercase'>{getLanguageValue(item.description.values)}</small>
                                                    </div>}
                                                    <div>
                                                        <small className='text-uppercase'>{formatedDate(item.uploadtime ?? '')} - {item.uploadByDisplayName ?? ''}</small>
                                                    </div>
                                                </div>
                                            </StyledDocumentWrapper>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="d-flex justify-content-end">
                                            {item.isOldVersion && <div data-toggle="tooltip" data-placement="right" title={t('documents:reactivate')}>
                                                <StyledImage style={{ cursor: "pointer" }} image={DocumentReactivateIcon} onClick={() => { setDocument(item); setOpenReactivateModal(true) }} />
                                            </div>}
                                            <div data-toggle="tooltip" data-placement="right" title={t('delete')}>
                                                <StyledImage style={{ cursor: "pointer" }} image={DocumentDeleteIcon} onClick={() => { setDocument(item); setOpenDeleteModal(true) }} />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            )
                        })}
                        {openDeleteModal && (<ModalComponent
                            ModalTitle={document?.name}
                            functionButton1={() => handleDeleteDocument()}
                            textButton1={t('delete')}
                            variantButton1="danger"
                            variantBody="alert-danger"
                            BodyPart1={t('documents:deleteDocumentBody')}
                            functionCancel={() => { setOpenDeleteModal(false) }}
                        />)}
                        {openReactivateModal && (<ModalComponent
                            ModalTitle={document?.name}
                            functionButton1={() => handleReactivateDocument()}
                            textButton1={t('yes')}
                            variantButton1="danger"
                            variantBody="alert-danger"
                            BodyPart1={t('documents:reactivateDocumentBody')}
                            functionCancel={() => { setOpenReactivateModal(false) }}
                        />)}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => handleClose()}>
                        {t('cancelButton')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default HistoryDocumentModal
